import React, { useEffect, useState } from 'react';
import { Typography, Input, Row, Col, Button, Space, message } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import {useParams} from 'react-router-dom';
import { Section } from '../../components/UI/Section.component';
import PromotionService from '../../services/promotion.service';
import { EditPromotionForm } from '../../components/Dashboard/Promotion/EditPromotionForm';

const { Title } = Typography;

export const EditPromotionScreen = () => {

    const params = useParams();
    const [promotion, setPromotion] = useState({})
    const [branches, setBranches] = useState({})
    const [isLoaded, setIsLoaded] = useState(false)
    
    useEffect(() => {
        let data =  {id: params.id};
        PromotionService.getPromotion(data).then(
          (response) => {
            setPromotion(response.data.promotion);
            setBranches(response.data.branches);
            setIsLoaded(true);
          },
          (error) => {
              // console.log(error.response.data.message)
          }
        );
    }, [])


    return(
        <>
            <Screen id="">
                <Container >
                    <Section style={{width: '600px'}}>
                        <Row justify="space-between " style={{gap:"10px",}}>
                            <Col>
                                { isLoaded && <EditPromotionForm promotion={promotion} branches={branches} promotionID={params.id} />}
                            </Col>
                        </Row>
                    </Section>
                </Container>
            </Screen>
        </>
    )
}
